/** 微信 / 移动端视频全屏与横屏辅助 */

const PLAY_KEY = 'coolpeople_course_play'

export function stashCoursePlayPayload(payload) {
  try {
    sessionStorage.setItem(PLAY_KEY, JSON.stringify(payload || {}))
  } catch (_) {
    /* ignore quota */
  }
}

export function readCoursePlayPayload() {
  try {
    return JSON.parse(sessionStorage.getItem(PLAY_KEY) || '{}')
  } catch (_) {
    return {}
  }
}

export function isWechatBrowser() {
  if (typeof navigator === 'undefined') return false
  return /MicroMessenger/i.test(navigator.userAgent || '')
}

export function isMobileBrowser() {
  if (typeof navigator === 'undefined') return false
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '')
}

/** 给原生 video 打上微信 X5 / iOS 内联与全屏相关属性 */
export function applyWechatVideoAttrs(videoEl) {
  if (!videoEl || videoEl.tagName !== 'VIDEO') return
  videoEl.setAttribute('playsinline', 'true')
  videoEl.setAttribute('webkit-playsinline', 'true')
  videoEl.setAttribute('x5-playsinline', 'true')
  videoEl.setAttribute('x5-video-player-type', 'h5')
  videoEl.setAttribute('x5-video-player-fullscreen', 'true')
  videoEl.setAttribute('x5-video-orientation', 'landscape')
  videoEl.playsInline = true
}

/**
 * 尽量进入系统全屏；失败返回 false，由调用方走 CSS 横屏兜底。
 */
export async function tryNativeVideoFullscreen(videoEl) {
  if (!videoEl) return false
  try {
    if (typeof videoEl.webkitEnterFullscreen === 'function') {
      videoEl.webkitEnterFullscreen()
      return true
    }
  } catch (_) {
    /* iOS 可能拒绝 */
  }
  const req =
    videoEl.requestFullscreen ||
    videoEl.webkitRequestFullscreen ||
    videoEl.webkitRequestFullScreen ||
    videoEl.mozRequestFullScreen ||
    videoEl.msRequestFullscreen
  if (typeof req === 'function') {
    try {
      await req.call(videoEl)
      return true
    } catch (_) {
      /* WeChat 常拒绝 */
    }
  }
  const docEl = document.documentElement
  const docReq =
    docEl.requestFullscreen ||
    docEl.webkitRequestFullscreen ||
    docEl.webkitRequestFullScreen
  if (typeof docReq === 'function') {
    try {
      await docReq.call(docEl)
      return true
    } catch (_) {
      /* ignore */
    }
  }
  return false
}

export async function exitNativeFullscreen() {
  const exit =
    document.exitFullscreen ||
    document.webkitExitFullscreen ||
    document.webkitCancelFullScreen ||
    document.mozCancelFullScreen ||
    document.msExitFullscreen
  if (typeof exit === 'function' && (document.fullscreenElement || document.webkitFullscreenElement)) {
    try {
      await exit.call(document)
    } catch (_) {
      /* ignore */
    }
  }
}

/** 尝试锁定横屏（多数微信内无效，有则更好） */
export async function tryLockLandscape() {
  try {
    const o = screen.orientation || screen.mozOrientation || screen.msOrientation
    if (o && typeof o.lock === 'function') {
      await o.lock('landscape')
      return true
    }
  } catch (_) {
    /* WeChat / iOS 通常不支持 */
  }
  return false
}

export async function tryUnlockOrientation() {
  try {
    const o = screen.orientation
    if (o && typeof o.unlock === 'function') {
      o.unlock()
    }
  } catch (_) {
    /* ignore */
  }
}
